module.exports = __webpack_public_path__ + "media/assets/community/logo-atlas-4170f0810f2105c44c99993db8472915eee9cf67c41c96331823ac90f8d39e4c.png";